// Libs
import { useState } from 'react';
import { notification } from 'antd';
// Services
import { ApiServiceV2 } from 'services';

const useCreatePaycut = () => {
	const [isLoading, setIsLoading] = useState(false);

	const submitPaycut = ({ payload, onSuccess }) => {
		if (!payload.name?.trim()) {
			notification.warning({ message: 'El nombre es requerido', className: 'notification-dark-style', duration: 5 });
			return;
		}
		if (!payload.from_date) {
			notification.warning({ message: 'La fecha de inicio es requerida', className: 'notification-dark-style', duration: 5 });
			return;
		}
		if (!payload.to_date) {
			notification.warning({ message: 'La fecha de fin es requerida', className: 'notification-dark-style', duration: 5 });
			return;
		}
		if (!payload.department_id) {
			notification.warning({ message: 'El departamento es requerido', className: 'notification-dark-style', duration: 5 });
			return;
		}
		if (!payload.coin_id) {
			notification.warning({ message: 'La moneda es requerida', className: 'notification-dark-style', duration: 5 });
			return;
		}

		setIsLoading(true);
		ApiServiceV2.post({ url: '/paycuts/invoice', data: payload })
			.then(() => {
				notification.success({ message: 'Cobro creado exitosamente', className: 'notification-dark-style', duration: 5 });
				onSuccess?.();
			})
			.catch(() => {
				notification.error({ message: 'No se pudo crear el cobro', className: 'notification-dark-style', duration: 5 });
			})
			.finally(() => setIsLoading(false));
	};

	return { submitPaycut, isLoading };
};

export default useCreatePaycut;
